import { render, staticRenderFns } from "./_Dashboard.vue?vue&type=template&id=dadd1628&scoped=true&"
import script from "./_Dashboard.vue?vue&type=script&lang=js&"
export * from "./_Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./_Dashboard.vue?vue&type=style&index=0&id=dadd1628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadd1628",
  null
  
)

export default component.exports